import '../App.css';
import React, { useState, useEffect } from "react";
import { Row, Col, Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import pdf from '../pdfs/tories.pdf'; 
import { Helmet } from 'react-helmet';

function Page() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  function renderLinks() {
    return (
      <div style={{lineHeight: isMobile ? '1' : '', fontSize: isMobile ? '15px' : ''}}>
        Source:<br /><br />
		Manuscript held by G. W. Leibniz Bibliothek, Hanover<br />
		Shelfmark Ms 30, 1669 Bl. 28<br /><br />
		{isMobile ? '' : <hr className="centered-hr" />}
		Date: 1671 (?)<br /><br />
        Translated from the French<br /><br /> 
        {isMobile ? '' : <hr className="centered-hr" />}
        <Link to={pdf} target="_blank">View this translation in PDF format (169k)</Link>
      </div>
    );
  }
  
  return (
    <div>
        <Helmet>
            <title>On the Word 'Tories'</title>
            <meta name="description" content="An English translation of ON THE WORD 'TORIES' by Gottfried Wilhelm Leibniz, from 1671 (?)" />
        </Helmet>
        <Routes>
          <Route path="/" element={
            <Container fluid className="Container">
              <Row className="main-content">
                <Col md={3} className={`LeftColumn ${isMobile ? 'mobile' : ''}`}>
                  {isMobile ? (
                    <></>
                  ) : (
                    <>
                    {renderLinks()}<br></br>
                 
                    </>
                  )}
                </Col>
                <Col md={8} className={`RightColumn ${isMobile ? 'mobile' : ''}`}>
                  <h2 id='top' className={`PageTitle ${isMobile ? 'mobile' : ''}`}>LEIBNIZ: ON THE WORD "TORIES"</h2>
                  {isMobile ? (
                    <>
                    {renderLinks()}  
                    </>
                  ) : (
                    <>
                    
                    </>
                  )}
                 <br />
                 <small>These remarks were written on one side of a small scrap of paper torn from a larger sheet. Leibniz quotes from a book by Thomas Sprat; he wrote marginal notes on the book in 1671,<a name="1" href="#note1"><sup>1</sup></a> suggesting that this piece is from the same time. He cites Sprat's book in other contemporaneous writings.</small><a name="2" href="#note2"><sup>2</sup></a><br /><br />
                 [<b>Ms 30, 1669 Bl. 28</b>]<br /><br />
                 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;“Tories” is a word that formerly signified the Irish natives scattered throughout the country, enemies of the English, and almost savages, thieves, and murderers. Here is a passage from Mr. Sprat in <var>The History of the Royal Society</var>, p. 385 of the English edition of London, 1667. 4º.<br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;“The flax of which we stand so much in need, may prosper in Ireland in many vast Tracts of Ground, now only possessed by Wild Beasts, or Tories almost as Wild.”<a name="3" href="#note3"><sup>3</sup></a>
                <br /><br /><br />
                <hr className='rightcol-hr' />
                <br /><br />
                NOTES:<br /><br />
                <a name="note1" href="#1">1.</a> Erfurt UB 03 - Eu. 8° 03220.<br />
                <a name="note2" href="#2">2.</a> See for example A VIII 2, 650.<br />
                <a name="note3" href="#3">3.</a> Thomas Sprat, <var>The History of the Royal-Society of London for the Improving of Natural Knowledge</var> (London: T. R., 1667), 385.<br /><br /><br />
                &#169; Lloyd Strickland 2024
                <br></br><br></br>
                </Col>
                <Col md={1}></Col>
              </Row>
              <Row className="footer"><h6>&copy; LLOYD STRICKLAND 2003-{new Date().getFullYear()}</h6></Row>
            </Container>
          } />
        </Routes>
      </div>
  );
}

export default Page;
